import styled from '@emotion/styled';
import { TextField } from '@mui/material';

import { turquoise, black87, whisperGray } from '~/styles';

export const SearchBarInput = styled(TextField)`
  width: 100%;
  border-radius: 4px;
  justify-content: center;

  & label.Mui-focused {
    color: ${turquoise};
  }
  & .MuiInput-underline:after {
    border-color: ${turquoise};
  }
  & .MuiOutlinedInput-root {
    color: ${black87};
    border-radius: 4px;
    border-style: none;
    background-color: ${whisperGray};
    &:hover fieldset {
      border-style: solid;
      border-color: ${turquoise};
    }

    & fieldset {
      border-style: none;
    }
    &.Mui-focused fieldset {
      border-style: solid;
      border-color: ${turquoise};
    }
  }
` as typeof TextField;
